/**
 * 将「最小货币单位」（如美分 cents）格式化为主要单位的小数字符串。
 * 例如 2999 → "29.99"（不带头货币符号，由调用方拼接 `currency_sign`）。
 *
 * 用整除 + 取模在整数域内计算，避免 `cents / 100` 的 IEEE754 二进制误差传递到展示层。
 */
export function formatMinorUnitsAsDecimal(amountMinor: number, fractionDigits = 2): string {
    const fd = Math.min(10, Math.max(1, Math.floor(fractionDigits)));
    const scale = 10 ** fd;

    if (!Number.isFinite(amountMinor)) {
        return `0.${'0'.repeat(fd)}`;
    }

    const rounded = Math.round(amountMinor);
    const negative = rounded < 0;
    const abs = Math.abs(rounded);
    const major = Math.trunc(abs / scale);
    const fraction = abs % scale;

    const fractionStr = String(fraction).padStart(fd, '0');

    return `${negative ? '-' : ''}${major}.${fractionStr}`;
}
